import PropTypes from 'prop-types';
import useLocalize from '../../../utils/hooks/useLocalize';
import ScanCardBase from './ScanCardBase';

/**
 * CannedScanCard Component - Displays a pre-set scan card with title and description
 *
 * @param {Object} props Component props
 * @param {string} props.title The title of the scan
 * @param {string} props.description The description of the scan
 * @returns {React.Component} Canned scan card display component
 */
const CannedScanCard = ({
  scan,
  title,
  description,
  onDetailsClick,
  onClick,
  active
}) => {
  const localize = useLocalize();

  const handleDetailsClick = () => {
    onDetailsClick?.(scan, description);
  };

  return (
    <ScanCardBase
      className="canned-scan-card"
      title={title}
      detailsLabel={localize('desktop.scans.more.details')}
      onDetailsClick={handleDetailsClick}
      active={active}
      onClick={onClick}
    >
      <p className="scan-card-base-body-text">{description}</p>
    </ScanCardBase>
  );
};

CannedScanCard.propTypes = {
  scan: PropTypes.object,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onDetailsClick: PropTypes.func,
  onClick: PropTypes.func,
  active: PropTypes.bool
};

export default CannedScanCard;
